<template>
  <div class="flex flex-col-reverse md:flex-row">
    <div
      class="md:flex-1 min-w-0 h-full relative"
      :style="`height: ${isLargeScreen ? '480px' : 'calc(100vh - 72px)'}`"
    >
      <img class="block w-full h-full" src="@/assets/relation_bg.avif" alt="" />
      <RelationView
        :style="`height: ${isLargeScreen ? '480px' : 'calc(100vh - 72px)'}`"
        :data="state.data"
        v-if="!loading"
      ></RelationView>
    </div>
    <TopArtist
      class="mb-6 md:mb-0"
      :loading="loading"
      :data="state.data"
    ></TopArtist>
  </div>
</template>

<script setup>
import { queryArtistRank } from '@/api/common';
import { useDesktop, useReqByBool } from '@/hooks';
import { inject, onMounted, reactive, watch } from 'vue-demi';
import RelationView from './RelationView.vue';
import TopArtist from './TopArtist.vue';

const curChain = inject('curChain');
const homeState = inject('homeState');

const isLargeScreen = useDesktop();

const state = reactive({
  data: [],
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryArtistRank(
    curChain.value,
    homeState.filterStatus,
    true,
  );
  state.data = res.data;
});

watch(() => [curChain.value, homeState.filterStatus], loadData);

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
